import type React from 'react';

export const isAuthNavigationTarget = (target: EventTarget | null): boolean =>
    target instanceof Element && Boolean(target.closest('[data-auth-navigation]'));

// Navigation leaves the form intentionally. Keep its blur validation from
// changing layout between pointer-down and click, or while tabbing to a switch.
export const authFormBlur =
    <T extends HTMLElement>(handleBlur: (event: React.FocusEvent<T>) => void) =>
    (event: React.FocusEvent<T>): void => {
        if (!isAuthNavigationTarget(event.relatedTarget)) handleBlur(event);
    };
